// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { PropsWithChildren } from 'react';
import { Button, SxProps } from '@mui/material';

type SyncButtonProps = {
  sx?: SxProps;
  color?: 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  variant?: 'contained' | 'text' | 'outlined';
  disabled?: boolean;
  onClick: () => void;
};

export const SyncButton: React.FC<PropsWithChildren<SyncButtonProps>> = ({
  sx,
  color = 'primary',
  size = 'small',
  variant = 'contained',
  children,
  disabled,
  onClick,
}) => {
  const buttonStyle = {
    position: 'relative',
    paddingTop: 0,
    paddingBottom: 0,
    ...sx,
  } as SxProps;

  return (
    <Button
      sx={buttonStyle}
      color={color}
      size={size}
      variant={variant}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
